import React from "react";

// Minimalistic Bara Logo with geometric element
const BaraLogo = ({ height = 32, color = "#111111" }) => {
  const aspectRatio = 3.5; // width to height ratio
  const width = height * aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 140 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      {/* Geometric element - abstract hexagon/connection symbol */}
      <g>
        {/* Outer hexagon outline */}
        <path
          d="M20 4 L32 10 L32 22 L20 28 L8 22 L8 10 Z"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
        />
        {/* Inner dot */}
        <circle cx="20" cy="16" r="3" fill={color} />
        {/* Connection lines from center */}
        <line x1="20" y1="13" x2="20" y2="7" stroke={color} strokeWidth="1.2" />
        <line x1="22.6" y1="14.5" x2="28" y2="11.5" stroke={color} strokeWidth="1.2" />
        <line x1="22.6" y1="17.5" x2="28" y2="20.5" stroke={color} strokeWidth="1.2" />
        <line x1="20" y1="19" x2="20" y2="25" stroke={color} strokeWidth="1.2" />
        <line x1="17.4" y1="17.5" x2="12" y2="20.5" stroke={color} strokeWidth="1.2" />
        <line x1="17.4" y1="14.5" x2="12" y2="11.5" stroke={color} strokeWidth="1.2" />
      </g>

      {/* BARA text */}
      <text
        x="44"
        y="26"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
        fontSize="22"
        fontWeight="600"
        letterSpacing="0.08em"
        fill={color}
      >
        BARA
      </text>
    </svg>
  );
};

// Alternative: Simpler version with just a line accent
export const BaraLogoSimple = ({ height = 32, color = "#111111" }) => {
  const aspectRatio = 3;
  const width = height * aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      {/* Accent line */}
      <rect x="4" y="8" width="3" height="24" fill={color} />
      
      {/* BARA text */}
      <text
        x="16"
        y="26"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
        fontSize="22"
        fontWeight="600"
        letterSpacing="0.06em"
        fill={color}
      >
        BARA
      </text>
    </svg>
  );
};

// Alternative: With abstract B mark
export const BaraLogoMark = ({ height = 32, color = "#111111" }) => {
  const aspectRatio = 3.2;
  const width = height * aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 128 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      {/* Abstract B mark - two connected squares */}
      <rect x="6" y="6" width="12" height="12" stroke={color} strokeWidth="1.5" fill="none" />
      <rect x="6" y="22" width="12" height="12" stroke={color} strokeWidth="1.5" fill="none" />
      <line x1="18" y1="12" x2="24" y2="12" stroke={color} strokeWidth="1.5" />
      <line x1="18" y1="28" x2="24" y2="28" stroke={color} strokeWidth="1.5" />
      <circle cx="26" cy="20" r="2" fill={color} />
      
      {/* BARA text */}
      <text
        x="38"
        y="26"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
        fontSize="22"
        fontWeight="600"
        letterSpacing="0.06em"
        fill={color}
      >
        BARA
      </text>
    </svg>
  );
};

export default BaraLogo;
